import { ShippingPlanSelfServePrepOption } from "@deliverr/prep-service-client";
import { SimpleSellerSelfServePrepType } from "prep/types";

export const PREP_TYPE_TO_SELF_SERVE_TYPE: Record<SimpleSellerSelfServePrepType, ShippingPlanSelfServePrepOption> = {
  SKU_LABELS: "SELF_SERVE_SKU_LABELS",
  BAGGING_PROTECTION: "SELF_SERVE_BAGGING_PROTECTION",
  DAMAGE_PROTECTION: "SELF_SERVE_DAMAGE_PROTECTION",
  KITTING: "SELF_SERVE_KITTING",
};
